import { defineStore } from "pinia";
export const useThemeStore = defineStore("theme", {
  state: () => ({
    isDark: true,
    lang: "br",
  }),
  persist: {
    key: "store-theme",
  },
});
